import { types } from 'mobx-state-tree';

const GdprInfo = types.model('GdprInfo', {
  email: types.maybeNull(types.string),
  first_name: types.maybeNull(types.string),
  international_number: types.maybeNull(types.string),
  last_name: types.maybeNull(types.string),
  marketing_ban: types.boolean,
  street_address: types.maybeNull(types.string)
});

export default GdprInfo;
